import { RastreioCancerPerguntaDbEnum, RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

export const MamografiaPerguntaField = {
  noduloCaroco: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_01,
  riscoCancerMama: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_02,
  mamasExaminadas: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_03,
  fezMamografia: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_04,
  anoUltimaMamografia: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_05,
  fezRadioterapia: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_06,
  anoRadioterapiaMamaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_07,
  anoRadioterapiaMamaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_08,
  fezCirurgiaMama: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_01_09,
  dataSolicitacao: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_01,
  nomeResponsavel: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_02,
  cns: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_03,
  numeroConselho: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_04,
  siglaNomeConselho: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_09_05,
  biopsiaCirurgicaIncisionalDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_02,
  biopsiaCirurgicaIncisionalEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_03,
  biopsiaCirurgicaExcisionalDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_05,
  biopsiaCirurgicaExcisionalEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_06,
  centralectomiaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_08,
  centralectomiaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_09,
  segmentectomiaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_11,
  segmentectomiaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_12,
  dutectomiaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_14,
  dutectomiaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_15,
  mastectomiaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_17,
  mastectomiaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_18,
  mastectomiaPoupadoraPeleDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_20,
  mastectomiaPoupadoraPeleEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_21,
  mastectomiaPoupadoraPeleComplexoDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_23,
  mastectomiaPoupadoraPeleComplexoEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_24,
  linfadenectomiaAxilarDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_26,
  linfadenectomiaAxilarEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_27,
  biopsiaLinfonodoSentinelaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_29,
  biopsiaLinfonodoSentinelaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_30,
  reconstrucaoMamariaDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_32,
  reconstrucaoMamariaEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_33,
  mastoplastiaRedutoraDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_35,
  mastoplastiaRedutoraEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_36,
  inclusaoImplantesDireita: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_38,
  inclusaoImplantesEsquerda: RastreioCancerPerguntaDbEnum.PERGUNTA_MAMO_02_39,
} as const

type PerguntaFields = typeof MamografiaPerguntaField[keyof typeof MamografiaPerguntaField]

export type RequisicaoExameMamografiaFormValues = Partial<
  Record<PerguntaFields, RastreioCancerPerguntaOpcaoEnum | string>
>

export const mamasExaminadasOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM, label: 'Sim' },
  {
    value: RastreioCancerPerguntaOpcaoEnum.NUNCA_FORAM_EXAMINADAS_ANTERIORMENTE,
    label: 'Nunca foram examinadas anteriormente',
  },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO, label: 'Não' },
]

export const noduloCarocoOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_DIREITA, label: 'Sim, mama direita' },
  { value: RastreioCancerPerguntaOpcaoEnum.SIM_MAMA_ESQUERDA, label: 'Sim, mama esquerda' },
  { value: RastreioCancerPerguntaOpcaoEnum.NAO, label: 'Não' },
]

export const anamneseCirurgiaTableOptions = [
  {
    label: 'Biopsia cirúrgica incisional',
    valueDireita: MamografiaPerguntaField.biopsiaCirurgicaIncisionalDireita,
    valueEsquerda: MamografiaPerguntaField.biopsiaCirurgicaIncisionalEsquerda,
  },
  {
    label: 'Biopsia cirúrgica excisional',
    valueDireita: MamografiaPerguntaField.biopsiaCirurgicaExcisionalDireita,
    valueEsquerda: MamografiaPerguntaField.biopsiaCirurgicaExcisionalEsquerda,
  },
  {
    label: 'Centralectomia',
    valueDireita: MamografiaPerguntaField.centralectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.centralectomiaEsquerda,
  },
  {
    label: 'Segmentectomia',
    valueDireita: MamografiaPerguntaField.segmentectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.segmentectomiaEsquerda,
  },
  {
    label: 'Dutectomia',
    valueDireita: MamografiaPerguntaField.dutectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.dutectomiaEsquerda,
  },
  {
    label: 'Mastectomia',
    valueDireita: MamografiaPerguntaField.mastectomiaDireita,
    valueEsquerda: MamografiaPerguntaField.mastectomiaEsquerda,
  },
  {
    label: 'Mastectomia poupadora de pele',
    valueDireita: MamografiaPerguntaField.mastectomiaPoupadoraPeleDireita,
    valueEsquerda: MamografiaPerguntaField.mastectomiaPoupadoraPeleEsquerda,
  },
  {
    label: 'Mastectomia poupadora de pele e complexo aréolo-papilar',
    valueDireita: MamografiaPerguntaField.mastectomiaPoupadoraPeleComplexoDireita,
    valueEsquerda: MamografiaPerguntaField.mastectomiaPoupadoraPeleComplexoEsquerda,
  },
  {
    label: 'Linfadenectomia axilar',
    valueDireita: MamografiaPerguntaField.linfadenectomiaAxilarDireita,
    valueEsquerda: MamografiaPerguntaField.linfadenectomiaAxilarEsquerda,
  },
  {
    label: 'Biopsia de linfonodo sentinela',
    valueDireita: MamografiaPerguntaField.biopsiaLinfonodoSentinelaDireita,
    valueEsquerda: MamografiaPerguntaField.biopsiaLinfonodoSentinelaEsquerda,
  },
  {
    label: 'Reconstrução mamária',
    valueDireita: MamografiaPerguntaField.reconstrucaoMamariaDireita,
    valueEsquerda: MamografiaPerguntaField.reconstrucaoMamariaEsquerda,
  },
  {
    label: 'Mastoplastia redutora',
    valueDireita: MamografiaPerguntaField.mastoplastiaRedutoraDireita,
    valueEsquerda: MamografiaPerguntaField.mastoplastiaRedutoraEsquerda,
  },
  {
    label: 'Inclusão de implantes',
    valueDireita: MamografiaPerguntaField.inclusaoImplantesDireita,
    valueEsquerda: MamografiaPerguntaField.inclusaoImplantesEsquerda,
  },
]

export const RISCO_CANCER_MAMA_TOOLTIP_TEXT = `O risco elevado envolve:
1. Mulheres com história familiar de, pelo menos, um parente de primeiro grau com 
   diagnóstico de:
   a. Câncer de mama antes dos 50 anos de idade;
   b. Câncer de mama bilateral ou câncer de ovário em qualquer faixa etária;
2. Mulheres com história familiar de câncer de mama masculino;
3. Mulheres com diagnóstico histopatológico de lesão mamária proliferativa com atipia ou 
   neoplasia lobular in situ;
4. Mulheres com história pessoal de câncer de mama.
`
